/**
 * @generated SignedSource<<f3fb57ba1a2d249d9f798c45dad11784>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WooviPayPlugin_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Payment_query">;
  readonly " $fragmentType": "WooviPayPlugin_query";
};
export type WooviPayPlugin_query$key = {
  readonly " $data"?: WooviPayPlugin_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"WooviPayPlugin_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WooviPayPlugin_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Payment_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "1dc43c21b3d940a30bd48e293dd87953";

export default node;
